module.exports = __webpack_public_path__ + "static/media/NUS MSL Logo.239d822b.jpg";